import { Layout } from "components/Layout/Layout";
import { useNav } from "../hooks/useNav";
import { UpdateHomeWorkNumber } from "./UpdateHomeWorkNumber";

export const UpdateHomeWorkNumberPage = () => {
  const { state: locationState } = useNav();
  if (!locationState) {
    return null;
  }

  const { account, fullPersonalDetails } = locationState;
  return (
    <Layout>
      <Layout.Header>Manage personal details</Layout.Header>
      <Layout.Main>
        <UpdateHomeWorkNumber
          account={account}
          fullPersonalDetails={fullPersonalDetails}
        />
      </Layout.Main>
    </Layout>
  );
};
